import React from 'react';
import BaseFilter, { BaseFilterParams } from './BaseFilter';
import { useFilterContext } from '../FilterV2Context';
import Toggle from '../../toggle/Toggle';

export type ToggleFilterProps = BaseFilterParams & {
    // e.g. has or is - will display {prefix} outstanding comments
    prefix?: string;
};

/**
 * Filter option that contains a simple on/off toggle.
 *
 * *Use Case*: Filtering an either or value.
 *
 * *Example*: Worksheet has outstanding comments.
 *
 * **NOTE** Falsy values are essentially ignored.
 *
 * @param props ToggleFilterProps
 */
function ToggleFilter({ id, label, prefix = 'has' }: ToggleFilterProps): JSX.Element {
    const ctx = useFilterContext();
    const { active } = ctx.getDraft(id, 'toggle');

    return (
        <BaseFilter id={id} label={label} activeCount={active ? 1 : 0} key={id} onMenuClose={console.log}>
            <div className="flex items-center gap-2">
                <label className="text-sm text-gray-700 shrink-0">{label}</label>
                <Toggle
                    onToggle={(v): void => {
                        ctx.updateValues('toggle', id, { active: v });
                    }}
                    type="short"
                    label={label}
                    defaultEnabled={active}
                />
            </div>
        </BaseFilter>
    );
}

export default ToggleFilter;
